export default __webpack_public_path__ + "static/media/ResumeIconss.34fb468a.svg";